import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiListItemButton(theme: Theme): MuiThemeComponentOverride<"MuiListItemButton"> {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.active": {
            " *": { color: theme.palette.brand.white[100].main },
            backgroundColor: theme.palette.brand.blue[300].main,
          },
          borderRadius: "0.25rem",
        },
      },
    },
  };
}
